import { render, staticRenderFns } from "./contact-box.vue?vue&type=template&id=15e854a2&"
import script from "./contact-box.vue?vue&type=script&lang=js&"
export * from "./contact-box.vue?vue&type=script&lang=js&"
import style0 from "./contact-box.vue?vue&type=style&index=0&id=15e854a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports